import React, { useState, useEffect} from "react";
import { Modal } from "react-bootstrap";
import utils from '../../../common/utils.js';

const FilterModal = ( props ) => {
	const data = props.data;
	const widgetModel = data.widgetModel;
	const widgetOptions = widgetModel?.options;
	const filterValues = data.filterValues;
	const setFilterValues = data.setFilterValues;
	const getPosts = data.getPosts;
	const setPage = data.setPage;
	let selectedMockFilters = [];
	let initialShowState = {};

	const [show, setShow] = useState(false);
	const [values, setValues] = useState(filterValues);
	const activeFilters = Object.values(values).some(value => 0 < value.length );

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	// if in editor, filters
	if (widgetModel.isStatic){
		if (widgetModel.staticData?.filters) {
			selectedMockFilters = selectedMockFilters.concat(widgetModel.staticData?.filters);
		}
		if (selectedMockFilters.length) {
			selectedMockFilters = selectedMockFilters.filter((filter) => widgetOptions.filters.some((elem) => filter.id === elem.id) );
		}
	}

	let filterBlocks = [];
	let filters = 'static' === widgetModel.mode ? [].concat(selectedMockFilters) : [].concat(data.filters);


	// Initialize Show All State
	filters.forEach(filter => {
		initialShowState[filter.id] = false;
	});

	const [showAll, setShowAll] = useState(initialShowState);

	const handleShowMoreClick = ( filterId ) => {
			setShowAll((prevState) => ({
				...prevState,
				[filterId] : !prevState[filterId]
			}));
	}

	const handleCheckboxChange = (e , filterId ) => {
		const value = String(e.currentTarget.getAttribute('data-value'));
		let formFilter = filters.find((filter) => filter.id === filterId);
		// metrics.clickTrack(e, 'cc-filter|' + filterId, 'click');
		if (formFilter) {
			let currentFilterValues = values[filterId] || [];
			let newFilterValues = {};
			let filterOption = formFilter.options.find((option) => {
				return String(option.value) === String(value);
			});
			if( Array.isArray(currentFilterValues) ){
				// Check if value already in array
				let existingOption = currentFilterValues.some( item => item.value === value );
				// If it's already in there, remove it
				if( existingOption ){
					currentFilterValues = currentFilterValues.filter( item => item.value !== value );
				} else {
					currentFilterValues.push(filterOption);
				}
			} else {
				currentFilterValues.push( filterOption );
			}
			newFilterValues[filterId] = currentFilterValues || null;
			setValues({ ...values, ...newFilterValues });
		}
	};

	const applyAll = () => {
		setValues(values);
		setFilterValues({ ...filterValues, ...values });
		getPosts();
		setPage(1);
		handleClose();
	}

	const clearAll = () => {
		let newFilterValues = {};
		for (const filter in values) {
				newFilterValues[filter] = []; // Empty out the array
		}
		setValues({...values, ...newFilterValues});
		setFilterValues( {...filterValues, ...newFilterValues} );
		getPosts();
		setPage(1);
		handleClose();
	}

	useEffect(() => {
		setValues(filterValues);
	  }, [filterValues]);


	const renderCheckboxFilter = ( filter ) => {
		const filterId = filter.id;
		const filterSize = filter?.options?.length || 0;
		if (1 > filterSize) {
			widgetModel.debug && console.error('cc:Widget.Form: filter has no options: ', filter);
			return '';
		}
		const showAllOptions = showAll[filterId]
		const visibleOptions = showAllOptions ? filter.options : filter.options.slice(0, 10);
		return (
			<div className="dfe-filter-taxonomy">
				<div className="dfe-filter-taxonomy-title-container">

					<h2 className="dfe-filter-taxonomy-title">{filter.label}</h2>
				</div>
				<div className="dfe-filter-taxonomy-list-container">
					{visibleOptions.map((option, index) => (
						<div key={filter.label + 'item' +index } className="dfe-filter-taxonomy-input">
							<input type="checkbox" className="dfe-filter-taxonomy-option" id={option.label} checked={ values[filterId] && utils.toArray(values[filterId]).some( item => item.value === option.value ) } value={option.value}  data-value={option.value} onChange={ e => handleCheckboxChange(e, filterId) } />
							<label htmlFor={option.label} className="dfe-filter-taxonomy-label">{option.label}</label>
						</div>
					))}
					{!showAllOptions && 10 < filter.options.length && (
						<button className="dfe-filter-taxonomy-show-button" onClick={ () => handleShowMoreClick(filterId)}>Show More +</button>
					)}
					{showAllOptions && 10 < filter.options.length  && (
						<button className="dfe-filter-taxonomy-show-button" onClick={ () => handleShowMoreClick(filterId)}>Show Less</button>
					)}
				</div>
			</div>
		)
	}

	if (filters.length) {
		filters.forEach((filter) => {
			let filterBlock;
				filterBlock = renderCheckboxFilter(filter);
			if (filterBlock) {
				filterBlocks.push(filterBlock);
			}
		});
	}

	return (
		<>
		<button  onClick={handleShow} className="dfe-filter-modal-trigger">
			Filter <span className="cdc-fa-sliders-simple"></span>
		</button>
			<Modal show={show} onHide={handleClose} dialogClassName="dfe-filter-modal">
				<Modal.Header>
					<button onClick={handleClose} className="dfe-filter-modal-close-button">
						<span className="cdc-fa-circle-xmark"></span>
					</button>
				</Modal.Header>
				<Modal.Body>
				{filterBlocks.map((filterBlock, filterBlockId) => {
				return (
					<div key={'filter-block-' + filterBlockId} className="dfe-filter-taxonomy">
							{filterBlock}
					</div>
				);
				})}
				</Modal.Body>
				<Modal.Footer>
					<div className="dfe-filter-modal-button-container">
						<button onClick={clearAll} disabled={ !activeFilters } className={`dfe-filter-modal-clear-button ${ activeFilters ? 'active' : ''} `}>Clear All</button>
						<button onClick={applyAll} disabled={ !activeFilters } className={`dfe-filter-modal-apply-button ${ activeFilters ? 'active' : ''} `}>Apply</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default FilterModal;
